import { Box, Typography } from '@mui/material';
import React from 'react';
import { customPalette } from '../themes/customTheme';

export const ProgressBarGradient = ({ percentage }) => {
  if (percentage % 1 !== 0) {
    percentage = parseFloat(percentage.toFixed(2));
  }
  return (
    <>
      <Box
        sx={{
          mr: 1,
        }}
      >
        <Box
          sx={{
            backgroundColor: `${customPalette.greyStoke}`,
            height: 8,
            width: '170px',
            borderRadius: 5,
            position: 'relative',
          }}
        >
          <Box
            sx={{
              height: '100%',
              maxHeight: '8px',
              borderRadius: 5,
              position: 'absolute',
              width: `${percentage <= 100 ? percentage : 100}%`,
              top: 0,
              left: 0,
              overflow: 'hidden',
            }}
          >
            <Box
              sx={{
                width: '170px',
                height: '100%',
                maxHeight: '8px',
                borderRadius: 5,
                background:
                  'linear-gradient(270deg, #19E63B 0%, #99E052 28.5%, #FFC94A 55.5%, #E86A2E 78.5%, #D31314 100%)',
              }}
            />
          </Box>
        </Box>
      </Box>
      <Typography
        width={'min-content'}
        fontSize={14}
        fontWeight={600}
        lineHeight="19px"
      >
        {percentage + '%'}
      </Typography>
    </>
  );
};
